// extracted by mini-css-extract-plugin
export default {"SmallChartCard":"SmallChartCard_SmallChartCard__dRtCO","TitleCard":"SmallChartCard_TitleCard__1EA2h","imgIndicadorDeshabilitado":"SmallChartCard_imgIndicadorDeshabilitado__jDU3a"};